import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/47/thumb-landscape.jpg"


const Post47 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>誰もが憧れる、世界的ブランドCHANEL（シャネル）＝MATELASSE（マトラッセ）というイメージの方は多いのではないでしょうか？<br></br>実はこのMATELASSE（マトラッセ）という名前、シリーズ名でバッグの正式名称ではないんです。<br></br>今回は、一般的にMATELASSE（マトラッセ）と呼ばれているバッグの種類、サイズをご紹介していきます。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2>目次</h2>
        <p>
          <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80}>1.MATELASSE（マトラッセ）とは？</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec2" smooth={true} duration={500} offset={-80}>2.MATELASSE（マトラッセ）の歴史</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec3" smooth={true} duration={500} offset={-80}>3.MATELASSE（マトラッセ）の6つのサイズ展開</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec4" smooth={true} duration={500} offset={-80}>4.MATELASSE（マトラッセ）の素材</ScrollLink><br></br>
          <ScrollLink className="scroll" to="sec5" smooth={true} duration={500} offset={-80}>5.MATELASSE（マトラッセ）の持ち方</ScrollLink><br></br>  
          <ScrollLink className="scroll" to="sec6" smooth={true} duration={500} offset={-80}>6.その他のシェイプ（マトラッセシリーズ）</ScrollLink><br></br>  
          <ScrollLink className="scroll" to="sec7" smooth={true} duration={500} offset={-80}>7.まとめ</ScrollLink>
        </p>
      </div>               
      <div name="sec1" className="text-two-cloumn">
        <h2>1.MATELASSE（マトラッセ）とは？</h2>
        <p>マトラッセは、フランス語で「ふっくらしている」「袋詰めされた」という意味で、ひし形の縫い目を施すことによって、レザー部分がふっくらとしているものを指します。<br></br>一般的にマトラッセと言われているバッグには、ポイントが2つあります。（さまざまな見解があります。バッグの素材を称して全てのシェイプを「マトラッセ」と呼んでいる場合もあります。）<br></br><br></br>①チェーンショルダーにレザーが織りこまれているもの。<br></br>②フラップ部分の金具がシャネルの「C」を組み合わせたロゴマークのもの。
        </p>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/47/1.png" alt="タイムレスなエレガンス♡CHANEL（シャネル）MATELASSE（マトラッセ）の魅力"/>
      </figure>
      <span className="text-center">写真は主にマトラッセと呼ばれているものです。（マトラッセ23）</span>
      <figure className="img-small">
        <StaticImage src="../../images/posts/47/2.jpg"/>
      </figure>
      <p>バッグの裏側です。ここにはバックポケットがついており、開口部が優雅な弧を描く様子から“モナリザスマイル”とも呼ばれています。</p>     
      <div name="sec2" className="text-two-cloumn">
        <h2>2.MATELASSE（マトラッセ）の歴史</h2>      
      <p>
        1955年2月、ガブリエル シャネルはゴールドのチェーンをあしらったキルティング バッグをデザイン。このバッグは誕生した年にちなんで「2.55」と名付けられました。これが、現在のマトラッセの原点となります。<br></br>当時ショルダーバッグは男性のものという印象が強く、女性のバッグはハンドバッグが主流で非常に持ちにくかったため、ガブリエル シャネルはこのバッグにソフトなチェーンストラップを採用し、女性が自由に両手を使うことを可能にしました。<br></br>1983年、巨匠　カール ラガーフェルドがデザイナーに就任。このアイコンバッグ「2.55」を再解釈し、誕生したバッグ「11.12」が現在主に「マトラッセ」と言われている人気バッグです。「クラシック ハンドバッグ」とも呼ばれています。
      </p>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/47/3.jpg"/>
      </figure>
      <span className="text-center">写真は「2.55」</span>
      <p>「2.55」は金具部分がロゴではなく、チェーン部分もシンプルです。ですが、こちらも素材はマトラッセなので、マトラッセと呼ばれている場合もあります。</p>
      <Link to="https://laxus.co/app/pc/bags/chanel" className="view-all-button">
       CHANELのバッグを見る
      </Link>              
      <div name="sec3" className="text-max-width">
        <h2>3.MATELASSE（マトラッセ）の6つのサイズ展開</h2>
        <p>MATELASSE（マトラッセ）には現在、20・23・25・28・30・34の6つのサイズ展開があります。</p>         
      </div>
      <div className="text-max-width">
        <h2>■マトラッセ20(ミニマトラッセ) /18x12x7cm(幅x高さxマチ)</h2>
      </div>      
      <figure className="img-small">
        <StaticImage src="../../images/posts/47/4.jpg"/>
      </figure>
      <p>ミニマトラッセはとてもコンパクト。アクセサリー感覚といったところでしょうか？</p>            
      <div className="text-max-width">
        <h2>■マトラッセ23 /23x14x6.5cm(幅x高さxマチ)</h2> 
      </div>             
      <figure>
        <StaticImage src="../../images/posts/47/5.jpg"/>
      </figure>
      <p>小柄な方には、23サイズも人気。とてもすっきりとバランスよくお持ちいただけます。</p>
      <div className="text-max-width">
        <h2>■マトラッセ25 /25x15x6cm(幅x高さxマチ)</h2> 
      </div>             
      <figure>
        <StaticImage src="../../images/posts/47/6.jpg"/>
      </figure>
      <p>一番人気の定番 サイズ。長財布も収納可能で、マトラッセといえばこのサイズといった印象でしょうか？カジュアルコーデとの相性も抜群です♡</p>
      <div className="text-max-width">
        <h2>■マトラッセ28 /28x16x7cm(幅x高さxマチ)</h2> 
      </div>             
      <figure className="img-small">
        <StaticImage src="../../images/posts/47/7.jpg"/>
      </figure>
      <p>25と28が一般的に定番と言われているサイズです。カラーは黒が根強い人気ですが、ベージュなどもエレガントでステキですよね♡</p>
      <div className="text-max-width">
        <h2>■マトラッセ30（デカマトラッセ） /30x20x9cm(幅x高さxマチ)</h2> 
      </div>             
      <figure className="img-small">
        <StaticImage src="../../images/posts/47/8.jpg"/>
      </figure>
      <p>デカはフランス語で10倍という意味！（ギリシャ語のdecaが起源のようです。そういえば英語でもdecade（10年間）など言いますね）とっても大きいことが表現されており、デカマトラッセは書類も入る大きめサイズです。</p>
      <div className="text-max-width">
        <h2>■マトラッセ34（デカマトラッセ） /34x23x10cm(幅x高さxマチ)</h2> 
      </div>             
      <figure className="img-small">
        <StaticImage src="../../images/posts/47/9.png"/>
      </figure>
      <p>いちばん大きいサイズ、34。チェーンをダブルにしてショルダーにすると持ちやすいです。</p>
      <div name="sec4" className="text-max-width">
        <h2>4.MATELASSE（マトラッセ）の素材</h2>
        <p>MATELASSE（マトラッセ）の素材はさまざまなものがありますが、代表的な2種類を紹介いたします。</p>
      </div>
      <div className="text-max-width">
        <h2>■「キャビアスキン」</h2>
        <p>こちらは、牛革素材に型押したもの。型押しの模様がキャビアに似ていることからキャビアスキンと呼ばれています。 日本では圧倒的人気のキャビアスキンのマトラッセ。人気の理由は、キズが目立ちにくく、ラムスキンやカーフスキンと比べ、経年による変化の「ふっくら感」が損なわれにくいという点のようです。
        </p>
      </div>            
      <figure className="img-small">
        <StaticImage src="../../images/posts/47/10.png"/>
      </figure>
      <div className="text-max-width">
        <h2>■「ラムスキン」</h2>
        <p>羊革素材の「ラムスキン」。天然皮革のなめし革で、自然の風合いを残すためにあえてコーティングはされていません。ラムスキンは、生後１年以内の羊の皮革なので、デリケートで傷つきやすく、水分にも弱いです。柔らかく肌触りがとても良いです。
        </p>
      </div>
      <figure>
        <StaticImage src="../../images/posts/47/11.jpg"/>
      </figure>                                             
      <Link to="https://laxus.co/app/pc/bags/chanel" className="view-all-button">
       CHANELのバッグを見る
      </Link>         
      <div name="sec5" className="text-max-width">
        <h2>5.MATELASSE（マトラッセ）の持ち方</h2>
        <p>チェーンストラップを移動させて3wayでの持ち方が可能です。</p>
      </div>
      <div className="text-max-width">
        <h2>■ハンドバッグ</h2>
      </div>
      <figure>
        <StaticImage src="../../images/posts/47/12.jpg"/>
      </figure>
      <p>ストラップをダブル持ちで、エレガントなハンドバッグとして。セレモニースタイルにもぴったりです。</p>
      <div className="text-max-width">
        <h2>■ショルダーバッグ</h2>
      </div>
      <figure>
        <StaticImage src="../../images/posts/47/13.jpg"/>
      </figure>
      <p>写真はストラップダブルにしておりますが、シングルでショルダーバッグとしても♡</p>
      <div className="text-max-width">
        <h2>■ボディバッグ</h2>
      </div>
      <figure>
        <StaticImage src="../../images/posts/47/14.jpg"/>
      </figure>
      <p>ガブリエル シャネルが、女性のために考えた原型の持ち方！シングルストラップでボディバッグとして持つと、両手が開くのでデイリー使いに最適ですね。</p>          
      <div name="sec6" className="text-max-width">
        <h2>6.その他のシェイプ（マトラッセシリーズ）</h2>
        <p>ここまでは一般的にMATELASSE（マトラッセ）と呼ばれているバッグを紹介してきましたが、他のシェイプについても一部ご紹介します。</p>
      </div>
      <div className="text-max-width">
        <h2>■シングルフラップ</h2>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/47/15.png"/>
      </figure>
      <div className="text-max-width">
        <h2>■ラウンドフラップ</h2>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/47/16.jpg"/>
      </figure>
      <div className="text-max-width">
        <h2>■ハンドバッグタイプ</h2>
      </div>
      <figure className="img-small">
        <StaticImage src="../../images/posts/47/17.jpg"/>
      </figure>
      <div name="sec7" className="text-two-cloumn">
        <h2>7.まとめ</h2>
        <p>いかがでしたでしょうか？ココ（シャネルの愛称）が女性のために半世紀以上前に生み出したバッグは現在も色褪せることなく人気です。憧れのMATELASSE（マトラッセ）、1度持ってみませんか？
        </p>
      </div>
      <Link to="https://laxus.co/app/pc/bags/chanel" className="view-all-button">
       CHANELのバッグを見る
      </Link>  
    </section>
    <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post47

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 47}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
